<div *ngIf="networkErrorService.showError$ | async" class="network-error-overlay">
  <div class="network-error-box">
    <p>תקלת התחברות לרשת</p>
    <button class="retry-btn" (click)="networkErrorService.retry()">נסה שנית</button>
  </div>
</div>
<router-outlet></router-outlet>
